import {
  receivableStateOptions,
  customerTypeOptions,
  remindLevelOptions,
  leaseStatusOptions,
  leaseStatusKey,
} from './constants'
import { operateMaxShowLength } from '@/store/dict/config'

const validateNumber = (rule, value, callback) => {
  if (value && !/^\d+$/.test(value)) {
    callback(new Error('应收id只能输入数字'))
    return
  }
  callback()
}

// 表单验证信息
const rules = {
  receivableId: [
    { validator: validateNumber, trigger: 'blur' },
  ],
}

/**
 * 逾期明细表
 */
const config = function () {
  return {
    columns: [
      {
        name: 'receivableId',
        columnProps: {
          label: '应收ID',
          prop: 'receivableId',
          width: '100',
        },
      },
      {
        name: 'customerName',
        columnProps: {
          label: '客户名称',
          prop: 'customerName',
          width: 110,
        },
        showEllipsisTooltip: true,
        limitEllipsisLine: 1,
      },
      {
        name: 'customerType',
        columnProps: {
          label: '客户来源',
          prop: 'customerType',
        },
        render: ({ row }) => {
          const findItem = customerTypeOptions.find((item) => item.value === row.customerType)
          return this.$createElement('span', {}, (findItem && findItem.label) || '--')
        },
      },
      {
        name: 'idCardNo',
        columnProps: {
          label: '身份证号码',
          prop: 'idCardNo',
          width: '180px',
        },
      },
      {
        name: 'customerTel',
        columnProps: {
          label: '电话',
          prop: 'customerTel',
          width: '110px',
        },
      },
      {
        name: 'brandName',
        columnProps: {
          label: '品牌',
          prop: 'brandName',
        },
      },
      {
        name: 'seriesName',
        columnProps: {
          label: '车系',
          prop: 'seriesName',
        },
      },
      {
        name: 'modelName',
        columnProps: {
          label: '车型',
          prop: 'modelName',
          width: '160px',
        },
        showEllipsisTooltip: true,
        limitEllipsisLine: 1,
      },
      {
        name: 'plateNo',
        columnProps: {
          label: '车牌号',
          prop: 'plateNo',
          width: '100px',
        },
      },
      {
        name: 'orderState',
        columnProps: {
          label: '租赁状态',
          prop: 'orderState',
          width: '100px',
        },
        getText: ({ row }) => {
          return leaseStatusKey[row.orderState] || '--'
        },
      },
      {
        name: 'deposit',
        columnProps: {
          label: '实收押金（当前）',
          prop: 'deposit',
          width: '150px',
        },
        columnHeaderTooltip: '当前实收押金：一次性已交押金或分期付款时，显示已付款之和',
      },
      {
        name: 'receivableAmount',
        columnProps: {
          label: '应交租金（当前）',
          prop: 'receivableAmount',
          width: '150px',
        },
        columnHeaderTooltip: '默认优先显示当前月份应交租金，通过日期筛选可查看对应应收日期的应交租金',
      },
      {
        name: 'receivedAmount',
        columnProps: {
          label: '实收租金（当前）',
          prop: 'receivedAmount',
          width: '150px',
        },
        columnHeaderTooltip: '默认优先显示当前月份实收租金，通过日期筛选可查看对应应收日期的实收租金',
      },
      {
        name: 'surplusAmount',
        columnProps: {
          label: '未交租金（当前）',
          prop: 'surplusAmount',
          width: '150px',
        },
        columnHeaderTooltip: '应交租金（当前）-实收租金（当前）',
      },
      {
        name: 'dueDate',
        columnProps: {
          label: '应收日期',
          prop: 'dueDate',
          width: '100px',
        },
      },
      {
        name: 'receivableState',
        columnProps: {
          label: '还款状态',
          prop: 'receivableState',
        },
        render: ({ row }) => {
          const findItem = receivableStateOptions.find((item) => item.value === row.receivableState)
          return this.$createElement('el-tag', {
            props: {
              type: findItem && findItem.type,
            },
          }, (findItem && findItem.label) || '--')
        },
      },
      {
        name: 'operate',
        columnProps: {
          label: '操作',
          fixed: 'right',
          width: 240,
        },
        maxShowLength: operateMaxShowLength,
        getOperateList: ({ row }) => {
          const arr = []

          if (row.receivableState === 0 && this.judgePermission('under_lease_over_due_hasten_debt_remind_list_payment')) {
            arr.push({ name: 'toPayment', label: '催租收款', action: () => this.toPayment(row) })
          }
          return arr
        },
        type: 'operate',
      },
    ],
    rules,
    receivableStateOptions,
    customerTypeOptions,
    remindLevelOptions,
    leaseStatusOptions,
  }
}

export default config
